module.exports = __webpack_public_path__ + "img/newMech.d2282d9b.svg";